// extracted by mini-css-extract-plugin
export default {"StatsGroup":"StatusGroup_StatsGroup__z6h7C","Title":"StatusGroup_Title__H05q8"};